// extracted by mini-css-extract-plugin
export default {"payrollPage":"createPayroll_payrollPage__Vk4Kf"};